import { X } from "lucide-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

export interface Chip {
  key: string;
  label: string;
  onDismiss: () => void;
}

interface FilterChipsProps {
  chips: Chip[];
  onClearAll: () => void;
}

export function FilterChips({ chips, onClearAll }: FilterChipsProps): JSX.Element | null {
  const { t } = useTranslation("common");
  if (chips.length === 0) return null;

  return (
    <div
      role="region"
      aria-label={t("filters.active")}
      className="flex flex-wrap items-center gap-2"
      data-testid="filter-chips"
    >
      {chips.map((c) => (
        <button
          key={c.key}
          type="button"
          onClick={c.onDismiss}
          data-testid={`filter-chip-${c.key}`}
          className="inline-flex items-center gap-1 rounded-full border border-[var(--border-default)] bg-[var(--surface-sunken)] px-2 py-0.5 text-xs text-[var(--text-primary)] hover:bg-[var(--ink-100)] focus-ring transition-colors"
        >
          <span>{c.label}</span>
          <X className="h-3 w-3" aria-hidden />
        </button>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        data-testid="filter-chips-clear"
        className="text-xs font-medium text-[var(--brand-600)] hover:underline focus-ring rounded"
      >
        {t("filters.clear_all")}
      </button>
    </div>
  );
}
